import toast from '../../helpers/toast';
import {
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,
  FETCH_ADMIN_BY_ID_REQUEST,
  FETCH_ADMIN_BY_ID_SUCCESS,
  FETCH_ADMIN_BY_ID_FAILURE,
  FETCH_SELF_REQUEST,
  FETCH_SELF_SUCCESS,
  FETCH_SELF_FAILURE,
  DELETE_ADMIN_BY_ID_FAILURE,
  GENERAL_REQUEST,
} from '../../constants/ActionTypes';
import adminApi from '../../api/admin';
import storage from '../../storage';
import { setUrlHashPageNo } from '../../utils';
import { dataCheck, getPrev } from '../../helpers/table-api';
import {
  isSelfInfoFetching,
  isAdminByIdFetching,
  isAdminsFetching,
} from '../getters/admins';
import { USER } from '../../constants/cookies';

const updateUserDataCookie = (data) => {
  if (data && data.data && data.data.data && data.data.data._id) {
    const { email = '', name = '', roles = [], _id = '' } = data.data.data;

    storage.setItems({
      [USER]: { email, name, roles, _id },
    });
  }
};

export const fetchAdmins = (pageNo) => async (dispatch, getState) => {
  if (isAdminsFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_ADMINS_REQUEST,
  });

  try {
    let data = await adminApi.getAdmins(pageNo);
    const check = dataCheck(data);
    const prev = getPrev(data);
    data = check ? data : await adminApi.getAdmins(prev);

    if (!check) {
      // Ghost page
      setUrlHashPageNo(prev);
    }

    return dispatch({
      type: FETCH_ADMINS_SUCCESS,
      data: data,
    });
  } catch (error) {
    return dispatch({
      type: FETCH_ADMINS_FAILURE,
      data: error,
    });
  }
};

export const fetchAdminById = (id) => (dispatch, getState) => {
  if (isAdminByIdFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_ADMIN_BY_ID_REQUEST,
  });

  return adminApi
    .getAdminById(id)
    .then((data) => {
      return dispatch({
        type: FETCH_ADMIN_BY_ID_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: FETCH_ADMIN_BY_ID_FAILURE,
        data: error,
      });
    });
};

export const fetchSelfInfo = () => (dispatch, getState) => {
  if (isSelfInfoFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_SELF_REQUEST,
  });

  return adminApi
    .getSelfInfo()
    .then((data) => {
      updateUserDataCookie(data);

      return dispatch({
        type: FETCH_SELF_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: FETCH_SELF_FAILURE,
        data: error,
      });
    });
};

export const deleteAdminById = (id) => (dispatch) => {
  dispatch({
    type: GENERAL_REQUEST,
  });

  return adminApi
    .deleteAdmin(id)
    .then((res) => {
      if (res && res.data && res.data.message) {
        toast.success(res.data.message);
      }

      return res;
    })
    .catch((error) => {
      dispatch({
        type: DELETE_ADMIN_BY_ID_FAILURE,
        data: error,
      });

      return Promise.reject(error);
    });
};

export const createAdmin =
  ({ name, email, password, roles }) =>
  (dispatch) => {
    dispatch({
      type: GENERAL_REQUEST,
    });

    return adminApi
      .createAdmin({ name, email, password, roles })
      .then((res) => {
        toast.success('New Administrator created');
        return res;
      })
      .catch((error) => {
        toast.error('Failed to create New Administrator');
        return Promise.reject(error);
      });
  };

export const editAdmin =
  ({ id, name, email, password, roles }) =>
  (dispatch) => {
    dispatch({
      type: GENERAL_REQUEST,
    });

    return adminApi
      .editAdmin({ id, name, email, password, roles })
      .then((res) => {
        if (res && res.data && res.data.message) {
          toast.success(res.data.message);
        }
        return res;
      })
      .catch((error) => {
        toast.error('Failed to save');
        return Promise.reject(error);
      });
  };
